/**
 * RelevanceCell — inline native-select dropdown for the item-row
 * relevance column. Backend accepts exactly three values:
 *   relevant | not_relevant | unset
 * (verified against the legacy `updateUNR155Item` call site).
 */
import React from 'react';
import styles from './UNR155Tree.module.css';

const OPTIONS = [
  { value: 'unset', label: '—' },
  { value: 'relevant', label: 'Relevant' },
  { value: 'not_relevant', label: 'Not relevant' },
];

const RelevanceCell = ({ value, disabled, onChange }) => {
  const className = `${styles.relevanceSelect} ${styles[`relevance_${value}`] ?? ''}`;
  return (
    <select
      className={className}
      value={value || 'unset'}
      disabled={disabled}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => onChange(e.target.value)}
    >
      {OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};

export default RelevanceCell;
